




















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: { },
})
export default class Dropdown extends Vue {
  @Prop() name!: string
  @Prop({ default: 'no label' }) label!: string
  @Prop() options!: DropdownOption[]
  @Prop() value: string
  @Prop() autocomplete: string

  focussed: boolean = false

  setFocus () {
    this.focussed = true
  }

  setBlur (e: any) {
    this.focussed = false
    this.$emit('blur', e.target.value, this.name)
  }

  setSelected (e: any) {
    this.$emit('input', e.target.value)
  }
}
